
import * as yup from 'yup';

export const newPreagendamientoPymesSchema = yup.object({
  distancia: yup.string().optional(),
  coordenadas: yup.string().required('Campo Requerido'),
  fecha_instalacion: yup.string().required('Campo Requerido'),
  hora_instalacion: yup.string().required('Campo Requerido'),
  sector: yup.string().required('Campo Requerido'),
});

